import React from "react";
import PropTypes from "prop-types";

// RateSparkline draws a 0..1 daily automation-rate trend as a dependency-free inline
// <svg> (null days break the line). Visual sibling of SpendSparkline.
const W = 160, H = 28, PAD = 2;

const RateSparkline = ({ points = [] }) => {
  const vals = points.map((p) => (p && p.rate != null ? Number(p.rate) : null));
  if (vals.filter((v) => v != null).length < 2) return null;
  const innerW = W - PAD * 2, innerH = H - PAD * 2;
  const stepX = innerW / (vals.length - 1);
  const xOf = (i) => PAD + i * stepX;
  const yOf = (v) => PAD + innerH - v * innerH; // rate already 0..1
  const segs = [];
  let cur = [];
  vals.forEach((v, i) => {
    if (v == null) { if (cur.length) segs.push(cur); cur = []; }
    else cur.push(`${xOf(i).toFixed(1)},${yOf(v).toFixed(1)}`);
  });
  if (cur.length) segs.push(cur);
  return (
    <svg width="100%" height={H} viewBox={`0 0 ${W} ${H}`} preserveAspectRatio="none"
      role="img" aria-label="Automation rate, last 14 days" className="block">
      {segs.map((pts, i) => (
        <polyline key={i} points={pts.join(" ")} fill="none" stroke="hsl(var(--chart-1))"
          strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" vectorEffect="non-scaling-stroke" />
      ))}
    </svg>
  );
};
RateSparkline.propTypes = { points: PropTypes.arrayOf(PropTypes.shape({ date: PropTypes.string, rate: PropTypes.number })) };
export default RateSparkline;
